import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const styles = {
  maxHeight: '49px',
  maxWidth: '121px',
  paddingRight: '1rem'
}

const ClientLogoRenderer = ( { url } ) => {
  if (!url) {
    return null
  }
  // url here is the uri string
  return <img alt="Client Logo" style={styles} src={url} id="clientLogo" />
}

ClientLogoRenderer.propTypes = { url: PropTypes.string.isRequired }

export const mapStateToProps = (state) => ({ url: state.account.company && state.account.company.logo ? state.account.company.logo : '' })


export default connect(mapStateToProps)(ClientLogoRenderer)
